// extracted by mini-css-extract-plugin
module.exports = {"container":"forms-preview-header-module__container--OjAdP","previewIcon":"forms-preview-header-module__previewIcon--KBr71"};